import { isAskMeAnythingLoadedInTeamsQnaApp } from '@ms/yammer-data/dist/domains/teamsMeetings/selectors';

import { useSelector } from '../useSelector';

type UseIsAskMeAnythingLoadedInTeamsQnaApp = () => boolean;
export const useIsAskMeAnythingLoadedInTeamsQnaApp: UseIsAskMeAnythingLoadedInTeamsQnaApp = () =>
  useSelector((state) => isAskMeAnythingLoadedInTeamsQnaApp(state));
